/**
 * The two Order Queue counts beside "+ Manual order" (Phase 104, D-03 / D-26):
 * saved drafts at this location and manual orders held for art there.
 *
 * One `manualOrders.queue.badges` request per location; refetched when the
 * window regains focus, when the queue page mounts again (back from creating
 * an order), and when Mark approved or a draft delete invalidates it. Callers
 * mount it only for orders.create holders (the procedure refuses everyone
 * else), so other roles never send the request. A failed read hides both
 * entry points (the counts read 0); it never blocks the queue.
 */
import { trpc } from '@/lib/trpc';

export interface ManualOrderBadges {
  draftsCount: number;
  waitingOnArtCount: number;
}

export function useManualOrderBadges(locationId: string | undefined): ManualOrderBadges {
  const query = trpc.manualOrders.queue.badges.useQuery(
    { location_id: locationId ?? '' },
    {
      enabled: !!locationId,
      refetchOnWindowFocus: true,
    },
  );
  return {
    draftsCount: query.data?.draftsCount ?? 0,
    waitingOnArtCount: query.data?.waitingOnArtCount ?? 0,
  };
}
